import { createClient } from '@supabase/supabase-js';
import { createComponentLogger } from './logger';
import { isEmbeddedTemplatePreview } from './routeUtils';

const log = createComponentLogger('Supabase', 'initialization');

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-key';

// Only log in development
if (import.meta.env.DEV) {
  log.debug('Supabase client initializing', {
    urlConfigured: !!import.meta.env.VITE_SUPABASE_URL,
    keyConfigured: !!import.meta.env.VITE_SUPABASE_ANON_KEY,
    environment: import.meta.env.MODE
  });
}

// Create a client with default auth storage
// Let Supabase handle its own session management for proper RLS
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: isEmbeddedTemplatePreview()
    ? {
        // Embedded template-preview iframes: in-memory storage only — no
        // BroadcastChannel, no session recovery, no token refresh. With
        // persistSession enabled, each preview iframe would recover the
        // parent's localStorage session and broadcast SIGNED_IN back into the
        // parent app on every load.
        autoRefreshToken: false,
        persistSession: false,
        detectSessionInUrl: false
      }
    : {
        // Use default localStorage for consistent session management
        // This ensures auth.uid() works properly in RLS policies
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
        // Removed storage override - let Supabase use its defaults
      }
});

// Helper to check if Supabase is properly configured
export const isSupabaseConfigured = () => {
  return supabaseUrl !== 'https://placeholder.supabase.co' && 
         supabaseAnonKey !== 'placeholder-key' &&
         import.meta.env.VITE_SUPABASE_URL &&
         import.meta.env.VITE_SUPABASE_ANON_KEY;
};